import {
  SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST,
  SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_SUCCESS,
  SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_FAILURE,
  SWITCH_KEY_ENCRYPTION_TYPE_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const switchKeyEncryptionTypesReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SWITCH_KEY_ENCRYPTION_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SWITCH_KEY_ENCRYPTION_TYPE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default switchKeyEncryptionTypesReducer;
